
import "./VirtualClassL.css"
import img1 from "../../Images/UNSMoodleLogin.png"
import img2 from "../../Images/UNSMyCourses.png"
import img3 from "../../Images/RespectiveCourse.png"
import img4 from "../../Images/EnterRoom.png"
import img5 from "../../Images/JoinMeet.png"
import img6 from "../../Images/ExitClass.png"
import img7 from "../../Images/UNSRoomD2.png"
import img8 from "../../Images/ActivityGen2.png"
import img9 from "../../Images/EditActivity2.png"
import img11 from "../../Images/EditActivity.png"
import img10 from "../../Images/SaveActivity.png"
import img12 from "../../Images/DeleteActivity.png"

// import { Outlet } from "react-router-dom";


function VirtualClassL() {
    return (
      <div className="lecturerCover"> 

            <h1>Virtual Classes</h1>
              <div className="ContentOutput">
                    <div className="Hyperlinks">
                        <ul>
                             <li><a href="#Section1">Introduction to moodle</a>  </li>
                             <li><a href="#Section2">How to find the link to my class</a>  </li>
                             <li><a href="#Section3">How to join class</a> </li>
                             <li><a href="#Section3">Whats the Virtual claass exeperience</a> </li>
                             <li><a href="#Section4">How to exit a class</a> </li>
                           
                        </ul>

                    </div>
                    <div className="resourceSection">
                      
                          <section id="Section1">

                                <div className="contentWhole">  

                                      <div className="contentHeading">  
                                            <h3>Introduction to Moodle</h3>
                                            </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                          Moodle is the online learning platform used by Unilus. It contains individual spaces for each of your modules, where you can access a variety of information, materials, and activities. 
                                                      </p>    
                                                      <p> 
                                                        Almost all taught modules have a Moodle space.

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  

                                     </div>


                                </div>
   

                          </section>
                          <section id="Section2">

                                <div className="contentWhole">  

                                      <div className="contentHeading">  
                                            <h2>How to find links to my classes</h2>
                                            </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                         <b> STEP 1 :</b> Navigate to My courses
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img2} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                      <b>
                                                          STEP 2 : </b>Go to the respective course with the class
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img3} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                   <p> 
                                                         <b>STEP 3 :</b> Scroll through the course resources looking for Activity titles like <b>"LINK TO CLASS"</b> and click on it
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img8} />

                                     </div>
                                           
                                              
                                           


                                </div>
   

                          </section>
                          <section id="Section3">

                              
                                <div className="contentWhole">  

                                      <div className="contentHeading">  
                                            <h2>How to attend virtual classes </h2>
                                            </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                         <b> STEP 1 :</b> Navigate to My courses
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img2} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                      <b>
                                                          STEP 2 : </b>Go to the respective course with the class
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img3} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                   <p> 
                                                         <b>STEP 3 :</b> Scroll through the course resources looking for Activity titles like <b>"LINK TO CLASS"</b> and click on it
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img8} />

                                     </div>
                                           
                                                  <div className="contentParagraph"> 

                                                   <p> 
                                                         <b>STEP 4 :</b> Navigate and click on <b>Enter the Room</b>
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img4} />

                                     </div>
                                           
                                                  <div className="contentParagraph"> 

                                                   <p> 
                                                         <b>STEP 5 :</b> Click on <b>Join</b>
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img5} />

                                     </div>
                                           
                                              
                                           


                                </div>
   

   

                          </section>
                          <section id="Section4">

                                <div className="contentWhole">  

                                      <div className="contentHeading">  
                                            <h2>How to exit a class</h2>
                                            </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                          Like a phone call, Navigate to the red phone call icon and click on it to exit a call
                                                      </p>    
                                                      <p> 
                                                      

                                                      </p>    

                                                </div>

                                                <div className="contentParagraph"> 

                                                      <p> 
                                                            <b>STEP 1 :</b>  Navigate to the respective class(Activity) 
                                                            </p>   
                                                            <p> 
                                                            {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                                <div className="contentImage">  
                                             
                                                      <img src={img6} />

                                                </div>

                                                           


                                </div>
   

                          </section>

                    </div>
                 
              </div>
      
      </div>
    );
  }
  
  export default VirtualClassL;
  